import axios from '@/plugins/axios';

export function getConstByKey(key) {
  return axios.get('/const/getConstByKey', {
    params: {
      key: key
    }
  });
}
export function saveConst(key, value) {
  return axios.post('/const/saveConst', {
    key: key,
    value: value
  });
}
export function editConst(key, value) {
  return axios.post('/const/editConst', {
    key: key,
    value: value
  });
}
export function delConst(key) {
  return axios.post('/const/delConst', {
    key: key
  });
}
export function findConstList(params) {
  return axios.post('/const/findConstList', params);
}
